import React from "react"
import { gql, useMutation, useQuery } from "@apollo/client"

import General from "./containers/General"
import Settings from "./containers/Settings"

import { toast } from "react-hot-toast"

const SETTINGS = gql`
  query Trip($id: ID!) {
    trip(id: $id) {
      id
      name
      url
      slug
      code
      startDate
      type
      endDate
      image {
        id
        name
        url
      }

      destinations
      status
      # headline
      # summary

      # informations {
      #   id
      #   title
      #   summary
      #   image {
      #     url
      #   }
      #   index
      # }

      legal {
        contract
        excluded
        included
      }

      account
      agency {
        id
        name
        description
        logoURL
      }

      agents {
        id
        displayName
        email
        photoURL
      }

      leaders {
        id
        displayName
        email
        photoURL
      }

      payment {
        price
        deposits {
          category
          amount
          dueDate
        }
      }

      settings {
        creditCardPayment
        creditCardFee
        checkPayment
        checkPaymentDiscount
        lockTripDate
        minPassingers
        multiBooking
        notifications
        passengerFields
        reservationOnly
      }
    }
  }
`

const UPDATE_TRIP = gql`
  mutation UpdateTrip($input: UpdateTripInput!) {
    updateTrip(input: $input)
  }
`

const SettingsContainer = ({ tripId }) => {
  const { data, loading, error, refetch } = useQuery(SETTINGS, {
    variables: { id: tripId },
  })

  const [updateTrip] = useMutation(UPDATE_TRIP)

  const handleUpdateGeneral = async (values) => {
    const loadingId = toast.loading("Saving...")
    try {
      const input = { ...values }

      const res = await updateTrip({
        variables: { input },
        update(cache, { data }) {
          const existing = cache.readQuery({
            query: SETTINGS,
            variables: { id: tripId },
          })

          cache.writeQuery({
            query: SETTINGS,
            variables: { id: tripId },
            data: {
              trip: {
                ...existing?.trip,
                settings: {
                  ...existing?.trip?.settings,
                  ...values,
                },
              },
            },
          })
        },
      })

      toast.dismiss(loadingId)
      toast.success("Trip saved!")
      await refetch()
      return res
    } catch (error) {
      toast.dismiss(loadingId)
      toast.error("Could not save.")
      throw error
    }
  }

  const handleUpdateSettings = async (values) => {
    try {
      const input = { id: tripId, settings: { ...values } }
      await updateTrip({
        variables: { input },
        update(cache, { data }) {
          const existing = cache.readQuery({
            query: SETTINGS,
            variables: { id: tripId },
          })

          cache.writeQuery({
            query: SETTINGS,
            variables: { id: tripId },
            data: {
              trip: {
                ...existing?.trip,
                settings: {
                  ...existing?.trip?.settings,
                  ...values,
                },
              },
            },
          })
        },
      })
    } catch (error) {
      throw error
    }
  }

  return (
    <>
      {loading ? (
        <div className="bg-white rounded-lg shadow-lg">
          <div className="py-16  flex flex-col justify-center items-center">
            <div>...Loading...</div>
          </div>
        </div>
      ) : (
        <>
          <div className="bg-white rounded-lg shadow-lg">
            <General data={data?.trip} onSubmit={handleUpdateGeneral} />
          </div>
          <div className="bg-white rounded-lg shadow-lg mt-16">
            <Settings
              data={data?.trip?.settings}
              onSubmit={handleUpdateSettings}
            />
          </div>
        </>
      )}
    </>
  )
}

export default SettingsContainer
